import { createStyles } from '@mui/styles';
import { APTheme } from "../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  registrationButtons: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  "@keyframes onload": {
    "0%": {
      opacity: 0,
    },
    "100%": {
      opacity: 1,
    }
  },
  registrationContainerWrapper: {
    padding: '34px 35px'
  },
  registrationContainer: {
    display: 'flex',
    position: 'relative',
    zIndex: 100,
    background: '#F5F5F5',
    color: '#4a4a4a',
    fontSize: 16,
    letterSpacing: '-0.5px',
    height: '100%',
    animationName: `$onload`,
    animationDuration: '0.3s',
    animationFillMode: 'both',
    animationTimingFunction: 'cubic-bezier(0.680, -0.550, 0.265, 1.550) both',
    '@media(max-width: 1200px)': {
      paddingLeft: 80,
    },
    '@media(max-width: 768px)': {
      padding: 0,
    },
  },
  registrationSection: {
    padding: 30
  },
  registrationForm: {
    marginRight: 70,
    width: 610
  },
  stepTracker: {
    marginTop: 60
  },
  hide: {
    display: "none"
  },
  show: {
    display: "block"
  },
  fader: {
    transition: "opacity 0.7s linear",
    opacity: 1
  },
  fadedOut: {
    opacity: 0
  },
  spacingForms: {
    marginRight: 35,
    [theme.breakpoints.down('lg')]: {
      margin: "0 0 30px"
    },
    [theme.breakpoints.down('md')]: {
      margin: "0 0 30px"
    },
  }
});
